/*
 * 200 US business / office building addresses.
 * A stable one is chosen per site domain and injected into any element with
 * [data-store-address]. Same domain -> same address (not random per refresh);
 * different sites -> different address.
 */
(function () {
  var ADDRESSES = [
    "One World Trade Center, 285 Fulton St, New York, NY 10007",
    "Empire State Building, 350 5th Ave, New York, NY 10118",
    "30 Rockefeller Plaza, New York, NY 10112",
    "200 Park Ave, New York, NY 10166",
    "1 Bryant Park, New York, NY 10036",
    "620 8th Ave, New York, NY 10018",
    "11 Madison Ave, New York, NY 10010",
    "4 Times Square, New York, NY 10036",
    "601 Lexington Ave, New York, NY 10022",
    "1211 Avenue of the Americas, New York, NY 10036",
    "Willis Tower, 233 S Wacker Dr, Chicago, IL 60606",
    "Aon Center, 200 E Randolph St, Chicago, IL 60601",
    "875 N Michigan Ave, Chicago, IL 60611",
    "300 N LaSalle St, Chicago, IL 60654",
    "155 N Wacker Dr, Chicago, IL 60606",
    "One Prudential Plaza, 130 E Randolph St, Chicago, IL 60601",
    "Salesforce Tower, 415 Mission St, San Francisco, CA 94105",
    "555 California St, San Francisco, CA 94104",
    "101 California St, San Francisco, CA 94111",
    "1 Market St, San Francisco, CA 94105",
    "50 Fremont St, San Francisco, CA 94105",
    "US Bank Tower, 633 W 5th St, Los Angeles, CA 90071",
    "Wilshire Grand Center, 900 Wilshire Blvd, Los Angeles, CA 90017",
    "444 S Flower St, Los Angeles, CA 90071",
    "515 S Flower St, Los Angeles, CA 90071",
    "10250 Constellation Blvd, Los Angeles, CA 90067",
    "JPMorgan Chase Tower, 600 Travis St, Houston, TX 77002",
    "Wells Fargo Plaza, 1000 Louisiana St, Houston, TX 77002",
    "Bank of America Center, 700 Louisiana St, Houston, TX 77002",
    "1301 McKinney St, Houston, TX 77010",
    "Bank of America Plaza, 901 Main St, Dallas, TX 75202",
    "Renaissance Tower, 1201 Elm St, Dallas, TX 75270",
    "Comerica Bank Tower, 1717 Main St, Dallas, TX 75201",
    "300 Colorado St, Austin, TX 78701",
    "The Independent, 301 West Ave, Austin, TX 78701",
    "500 W 2nd St, Austin, TX 78701",
    "Frost Bank Tower, 111 Congress Ave, Austin, TX 78701",
    "Bank of America Plaza, 600 Peachtree St NE, Atlanta, GA 30308",
    "191 Peachtree Tower, 191 Peachtree St NE, Atlanta, GA 30303",
    "1180 Peachtree St NE, Atlanta, GA 30309",
    "3344 Peachtree Rd NE, Atlanta, GA 30326",
    "Comcast Center, 1701 John F Kennedy Blvd, Philadelphia, PA 19103",
    "One Liberty Place, 1650 Market St, Philadelphia, PA 19103",
    "1735 Market St, Philadelphia, PA 19103",
    "Columbia Center, 701 5th Ave, Seattle, WA 98104",
    "1201 3rd Ave, Seattle, WA 98101",
    "929 108th Ave NE, Bellevue, WA 98004",
    "10900 NE 4th St, Bellevue, WA 98004",
    "Republic Plaza, 370 17th St, Denver, CO 80202",
    "1801 California St, Denver, CO 80202",
    "1144 15th St, Denver, CO 80202",
    "Wells Fargo Center, 90 S 7th St, Minneapolis, MN 55402",
    "IDS Center, 80 S 8th St, Minneapolis, MN 55402",
    "50 S 6th St, Minneapolis, MN 55402",
    "Fifth Third Center, 511 Walnut St, Cincinnati, OH 45202",
    "Key Tower, 127 Public Square, Cleveland, OH 44114",
    "200 Public Square, Cleveland, OH 44114",
    "Rhodes State Office Tower, 30 E Broad St, Columbus, OH 43215",
    "Renaissance Center, 400 Renaissance Dr, Detroit, MI 48243",
    "One Detroit Center, 500 Woodward Ave, Detroit, MI 48226",
    "US Bank Plaza, 101 E 5th St, St Paul, MN 55101",
    "One Kansas City Place, 1200 Main St, Kansas City, MO 64105",
    "One US Bank Plaza, 505 N 7th St, St Louis, MO 63101",
    "Metropolitan Square, 211 N Broadway, St Louis, MO 63102",
    "Chase Tower, 111 Monument Cir, Indianapolis, IN 46204",
    "Salesforce Tower, 111 Monument Cir, Indianapolis, IN 46204",
    "US Bank Tower, 425 Walnut St, Cincinnati, OH 45202",
    "400 W Market St, Louisville, KY 40202",
    "AT&T Building, 333 Commerce St, Nashville, TN 37201",
    "Pinnacle at Symphony Place, 150 3rd Ave S, Nashville, TN 37201",
    "Bank of America Plaza, 101 S Tryon St, Charlotte, NC 28280",
    "Bank of America Corporate Center, 100 N Tryon St, Charlotte, NC 28202",
    "Duke Energy Center, 550 S Tryon St, Charlotte, NC 28202",
    "300 N Greene St, Greensboro, NC 27401",
    "Wells Fargo Capitol Center, 150 Fayetteville St, Raleigh, NC 27601",
    "Riverfront Plaza, 901 E Byrd St, Richmond, VA 23219",
    "James Monroe Building, 101 N 14th St, Richmond, VA 23219",
    "1717 Pennsylvania Ave NW, Washington, DC 20006",
    "1200 New Hampshire Ave NW, Washington, DC 20036",
    "1101 K St NW, Washington, DC 20005",
    "Legg Mason Building, 100 International Dr, Baltimore, MD 21202",
    "Transamerica Tower, 100 Light St, Baltimore, MD 21202",
    "One Boston Place, 201 Washington St, Boston, MA 02108",
    "Prudential Tower, 800 Boylston St, Boston, MA 02199",
    "One Financial Center, 1 Financial Center, Boston, MA 02111",
    "100 Federal St, Boston, MA 02110",
    "One International Place, Boston, MA 02110",
    "CityPlace I, 185 Asylum St, Hartford, CT 06103",
    "300 Atlantic St, Stamford, CT 06901",
    "Newport Tower, 525 Washington Blvd, Jersey City, NJ 07310",
    "Goldman Sachs Tower, 30 Hudson St, Jersey City, NJ 07302",
    "101 Hudson St, Jersey City, NJ 07302",
    "Bank of America Tower, 401 E Las Olas Blvd, Fort Lauderdale, FL 33301",
    "Southeast Financial Center, 200 S Biscayne Blvd, Miami, FL 33131",
    "Miami Tower, 100 SE 2nd St, Miami, FL 33131",
    "Wells Fargo Center, 333 SE 2nd Ave, Miami, FL 33131",
    "Bank of America Plaza, 101 E Kennedy Blvd, Tampa, FL 33602",
    "100 N Tampa St, Tampa, FL 33602",
    "SunTrust Center, 200 S Orange Ave, Orlando, FL 32801",
    "Wells Fargo Center, 1 Independent Dr, Jacksonville, FL 32202",
    "Bank of America Tower, 50 N Laura St, Jacksonville, FL 32202",
    "Chase Tower, 201 N Central Ave, Phoenix, AZ 85004",
    "US Bank Center, 101 N 1st Ave, Phoenix, AZ 85003",
    "2 N Central Ave, Phoenix, AZ 85004",
    "One America Plaza, 600 W Broadway, San Diego, CA 92101",
    "Symphony Towers, 750 B St, San Diego, CA 92101",
    "Emerald Plaza, 402 W Broadway, San Diego, CA 92101",
    "300 S 4th St, Las Vegas, NV 89101",
    "3993 Howard Hughes Pkwy, Las Vegas, NV 89169",
    "Wells Fargo Center, 299 S Main St, Salt Lake City, UT 84111",
    "222 S Main St, Salt Lake City, UT 84101",
    "US Bancorp Tower, 111 SW 5th Ave, Portland, OR 97204",
    "1300 SW 5th Ave, Portland, OR 97201",
    "Wells Fargo Center, 420 Montgomery St, San Francisco, CA 94104",
    "1 Almaden Blvd, San Jose, CA 95113",
    "50 W San Fernando St, San Jose, CA 95113",
    "2200 Mission College Blvd, Santa Clara, CA 95054",
    "1 Hacker Way, Menlo Park, CA 94025",
    "1600 Amphitheatre Pkwy, Mountain View, CA 94043",
    "1 Apple Park Way, Cupertino, CA 95014",
    "410 Terry Ave N, Seattle, WA 98109",
    "Onterie Center, 446 E Ontario St, Chicago, IL 60611",
    "500 W Madison St, Chicago, IL 60661",
    "71 S Wacker Dr, Chicago, IL 60606",
    "1 N Wacker Dr, Chicago, IL 60606",
    "227 W Monroe St, Chicago, IL 60606",
    "Three Allen Center, 333 Clay St, Houston, TX 77002",
    "Heritage Plaza, 1111 Bagby St, Houston, TX 77002",
    "Williams Tower, 2800 Post Oak Blvd, Houston, TX 77056",
    "Chase Tower, 2200 Ross Ave, Dallas, TX 75201",
    "Trammell Crow Center, 2001 Ross Ave, Dallas, TX 75201",
    "Fountain Place, 1445 Ross Ave, Dallas, TX 75202",
    "Sundance Square, 201 Main St, Fort Worth, TX 76102",
    "Frost Tower, 100 W Houston St, San Antonio, TX 78205",
    "Weston Centre, 112 E Pecan St, San Antonio, TX 78205",
    "Tower of the Americas, 739 E Cesar E Chavez Blvd, San Antonio, TX 78205",
    "1201 Louisiana St, Houston, TX 77002",
    "1000 Main St, Houston, TX 77002",
    "601 Poydras St, New Orleans, LA 70130",
    "Place St Charles, 201 St Charles Ave, New Orleans, LA 70170",
    "Regions Center, 400 W Capitol Ave, Little Rock, AR 72201",
    "BOK Tower, 100 W 5th St, Tulsa, OK 74103",
    "Devon Energy Center, 333 W Sheridan Ave, Oklahoma City, OK 73102",
    "First National Center, 120 N Robinson Ave, Oklahoma City, OK 73102",
    "Wells Fargo Center, 1700 Lincoln St, Denver, CO 80203",
    "Denver Place, 999 18th St, Denver, CO 80202",
    "1560 Broadway, Denver, CO 80202",
    "One Tabor Center, 1200 17th St, Denver, CO 80202",
    "101 W Colorado Ave, Colorado Springs, CO 80903",
    "Wells Fargo Tower, 420 20th St N, Birmingham, AL 35203",
    "Regions Harbert Plaza, 1901 6th Ave N, Birmingham, AL 35203",
    "Renasant Plaza, 190 E Capitol St, Jackson, MS 39201",
    "Regions Plaza, 1180 W Peachtree St NW, Atlanta, GA 30309",
    "Truist Plaza, 303 Peachtree St NE, Atlanta, GA 30308",
    "Promenade, 1230 Peachtree St NE, Atlanta, GA 30309",
    "Symphony Tower, 1180 Peachtree St NE, Atlanta, GA 30309",
    "100 N Main St, Winston-Salem, NC 27101",
    "Fifth Third Center, 201 N Tryon St, Charlotte, NC 28202",
    "One Wells Fargo Center, 301 S College St, Charlotte, NC 28202",
    "Dominion Tower, 999 Waterside Dr, Norfolk, VA 23510",
    "Bank of America Center, 1111 E Main St, Richmond, VA 23219",
    "Wachovia Tower, 213 Market St, Wilmington, DE 19801",
    "1201 N Market St, Wilmington, DE 19801",
    "PPG Place, 600 Grant St, Pittsburgh, PA 15219",
    "US Steel Tower, 600 Grant St, Pittsburgh, PA 15219",
    "One Oxford Centre, 301 Grant St, Pittsburgh, PA 15219",
    "Key Center, 40 Fountain Plaza, Buffalo, NY 14202",
    "Legacy Tower, 100 Chestnut St, Rochester, NY 14604",
    "Bausch & Lomb Place, 1 Bausch & Lomb Pl, Rochester, NY 14604",
    "State Tower Building, 109 S Warren St, Syracuse, NY 13202",
    "Corning Tower, Empire State Plaza, Albany, NY 12242",
    "One Commerce Plaza, 99 Washington Ave, Albany, NY 12210",
    "1 M&T Plaza, Buffalo, NY 14203",
    "Terminal Tower, 50 Public Square, Cleveland, OH 44113",
    "Fifth Third Center, 21 E State St, Columbus, OH 43215",
    "William Green Building, 30 W Spring St, Columbus, OH 43215",
    "One Nationwide Plaza, Columbus, OH 43215",
    "Fourth & Walnut Centre, 105 E 4th St, Cincinnati, OH 45202",
    "Great American Tower, 301 E 4th St, Cincinnati, OH 45202",
    "111 Monument Circle, Indianapolis, IN 46204",
    "OneAmerica Tower, 1 American Square, Indianapolis, IN 46282",
    "US Bank Center, 777 E Wisconsin Ave, Milwaukee, WI 53202",
    "100 E Wisconsin Ave, Milwaukee, WI 53202",
    "411 E Wisconsin Ave, Milwaukee, WI 53202",
    "US Bank Building, 200 S 6th St, Minneapolis, MN 55402",
    "Capella Tower, 225 S 6th St, Minneapolis, MN 55402",
    "Ameriprise Financial Center, 707 2nd Ave S, Minneapolis, MN 55402",
    "Ruan Center, 666 Grand Ave, Des Moines, IA 50309",
    "801 Grand, 801 Grand Ave, Des Moines, IA 50309",
    "First National Tower, 1601 Dodge St, Omaha, NE 68102",
    "US Bank Building, 233 S 13th St, Lincoln, NE 68508",
    "Wells Fargo Center, 100 W Washington St, Phoenix, AZ 85003",
    "Esplanade, 2555 E Camelback Rd, Phoenix, AZ 85016",
    "Camelback Esplanade, 2425 E Camelback Rd, Phoenix, AZ 85016",
    "One Renaissance Square, 2 N Central Ave, Phoenix, AZ 85004",
    "300 W Vine St, Lexington, KY 40507",
    "PNC Tower, 101 S 5th St, Louisville, KY 40202",
    "National City Tower, 101 S 5th St, Louisville, KY 40202",
    "Roberts Tower, 1010 Market St, St Louis, MO 63101",
    "Laclede Gas Building, 720 Olive St, St Louis, MO 63101"
  ];

  function hashString(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return h >>> 0;
  }

  function pickAddress() {
    var host = (window.location && window.location.hostname ? window.location.hostname : '')
      .toLowerCase()
      .replace(/^www\./, '');
    if (!host) return ADDRESSES[0];
    var idx = hashString(host) % ADDRESSES.length;
    return ADDRESSES[idx];
  }

  function apply() {
    var addr = pickAddress();
    var nodes = document.querySelectorAll('[data-store-address-disabled]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = addr;
    }
  }

  // expose in case other scripts need it
  window.STORE_ADDRESSES = ADDRESSES;
  window.getStoreAddress = pickAddress;

  if (document.readyState !== 'loading') {
    apply();
  } else {
    document.addEventListener('DOMContentLoaded', apply);
  }
})();
